<ion-header>
    <ion-toolbar>
        <ion-toolbar>
            Test Page
        </ion-toolbar>
    </ion-toolbar>
</ion-header>
<ion-content>
    <button ion-button (click)="checkIn()"></button>
</ion-content>